import React, { Component } from 'react';
import { Alert, Button, Card, CardBody, CardTitle, Form, FormGroup, Input, Label } from 'reactstrap';
import { Link } from 'react-router-dom';
import * as emailValidator from 'email-validator';
import { sendResetEmail } from '~/firebase/auth';
import { getMessage } from '~/utils/errorCodes';

export default class ForgotPasswordPage extends Component {
  state = {
    emailAddress: '',
    sending: false,
    error: null,
    sent: false
  };

  onInputChange = event => {
    this.setState({
      [event.target.name]: event.target.value
    });
  };

  sendResetPasswordLink = async event => {
    event.preventDefault();
    const { emailAddress } = this.state;

    if (!emailAddress.length || !emailValidator.validate(emailAddress)) {
      this.setState({
        error: 'Please enter a valid email address'
      });
      return;
    }

    this.setState({
      error: null,
      sending: true
    });

    try {
      await sendResetEmail(emailAddress);
      this.setState({
        sending: false,
        sent: true
      });
    } catch (err) {
      console.error('Error sending reset password link', err);
      this.setState({
        sending: false,
        error: 'Sorry, something unexpected happened'
      });
    }

    sendResetEmail(emailAddress).catch(err => {
      console.error('Error sending reset email', err);
      this.setState({
        loggingIn: false,
        error: getMessage(err.code)
      });
    });
  };

  renderForm = () => {
    const { email, sending } = this.state;

    return (
      <Form onSubmit={this.sendResetPasswordLink}>
        <FormGroup>
          <p>Enter your account email address below and we'll send out a link to reset your password.</p>
          <hr />
          <Label>Email address</Label>
          <Input type="email" name="emailAddress" value={email} onChange={this.onInputChange} />
        </FormGroup>
        <div className="flex justify-between align-items-center">
          <Button disabled={sending} color="primary">
            Send
          </Button>
          <Link to="/login">Back to login page</Link>
        </div>
      </Form>
    );
  };

  renderSent = () => {
    return (
      <div>
        <p>Done! An email to {this.state.emailAddress} will arrive shortly.</p>
        <p>
          <Link to="/login">Return to login page</Link>
        </p>
      </div>
    );
  };

  render() {
    const { error, sent } = this.state;

    const inner = sent ? this.renderSent() : this.renderForm();

    return (
      <div className="auth-container">
        <div className="absolute-center z-1">
          <Card className="auth-card">
            <CardBody>
              {error && <Alert color="danger">{error}</Alert>}
              <CardTitle className="tc">Forgotten password</CardTitle>
              {inner}
            </CardBody>
          </Card>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/forgotPassword/forgotPassword.jsx